// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  beatSlot: "SectionThreeFutures__beatSlot",
  beatTail: "SectionThreeFutures__beatTail",
  beats: "SectionThreeFutures__beats",
  card: "SectionThreeFutures__card",
  intro: "SectionThreeFutures__intro",
  lead: "SectionThreeFutures__lead",
  scenarioUnderline: "SectionThreeFutures__scenarioUnderline",
  scenarioWord: "SectionThreeFutures__scenarioWord",
  scrolly: "SectionThreeFutures__scrolly",
  section: "SectionThreeFutures__section",
  stage: "SectionThreeFutures__stage",
  sticky: "SectionThreeFutures__sticky",
  underlineSvg: "SectionThreeFutures__underlineSvg",
};
